import styled from 'styled-components';

import { INPUT_PADDING_HORIZONTAL } from '@front/common/src/components/input/styles';
import type { CommonIconProps } from '@front/common/src/types/components';

import Icon from '../../icon/icon';
import type { WithClassNameProps } from '../../types';

const StyledIconLabel = styled.label`
  display: flex;
  align-items: center;
  padding: 0 ${INPUT_PADDING_HORIZONTAL}px;
`;

type InputIconProps = WithClassNameProps &
  Pick<CommonIconProps, 'color' | 'name'> & {
    size?: number;
    inputId: string;
  };

const InputIcon = ({ inputId, size = 20, className, ...rest }: InputIconProps) => (
  <StyledIconLabel htmlFor={inputId} className={className}>
    <Icon size={size} {...rest} />
  </StyledIconLabel>
);

export default InputIcon;
